export const DEFAULT_STATE = {
  dashboardCarrierGraphData: {},
  carrierRateGraphData: {},
  equipmentTypeGraphData: {},
  carrierCountGraphData: {},
};
